import { useResolveUploadedPath, useTrans } from "../hooks";
import {
    Avatar,
    AvatarBadge,
    Badge,
    Flex,
    HStack,
    Text,
} from "@chakra-ui/react";
import { InternshipSchedule, MessageThread, User } from "../apis";
import { APPC } from "../config";

interface AppMessageThreadProps {
    data: MessageThread;
    loggedInUser: User;
    activeMessageThreadId?: number | null;
    onClickHandler: (messageThread: MessageThread) => void;
    isNew?: boolean;
}

export const AppMessageThread = ({
    data,
    loggedInUser,
    activeMessageThreadId,
    onClickHandler,
    isNew = false,
}: AppMessageThreadProps) => {
    const { t } = useTrans();
    const isActive = data.id === activeMessageThreadId;
    const member = Array.isArray(data?.members)
        ? (data.members as User[]).find((member) =>
              data.messageThreadType === APPC.BE.MessageThread.TYPE.TYPE_O2O
                  ? member?.meta?.id !== loggedInUser.id
                  : member?.meta?.userType ===
                    APPC.BE.User.USERTYPE.USERTYPE_STUDENT
          )
        : undefined;
    const isLoggedInUserTypeStudent =
        member?.meta?.userType === loggedInUser.userType;

    return (
        <HStack
            w={"full"}
            p={2}
            bg={
                isActive
                    ? "var(--chakra-colors-primaryT80)"
                    : "var(--chakra-colors-white)"
            }
            borderRadius={"0.5rem"}
            cursor="pointer"
            _hover={{
                bg: isActive
                    ? "var(--chakra-colors-primaryT80)"
                    : "var(--chakra-colors-primaryT90)",
            }}
            onClick={() => onClickHandler(data)}
        >
            {data.messageThreadType === APPC.BE.MessageThread.TYPE.TYPE_O2O ? (
                <>
                    <Avatar
                        size={"sm"}
                        name={member?.meta?.fullName}
                        src={useResolveUploadedPath(
                            APPC.BE.Upload.FILETYPE.FILETYPE_USER_AVATAR,
                            member?.meta?.imageName
                        )}
                        color={"var(--chakra-colors-primaryS10)"}
                        bgColor={"var(--chakra-colors-primaryT70)"}
                    >
                        {isNew && (
                            <AvatarBadge
                                boxSize="1em"
                                bg="var(--chakra-colors-destructive)"
                            />
                        )}
                    </Avatar>
                    <Flex direction={"column"} flexGrow={1} gap={0.5}>
                        <Text
                            textStyle={"mediumSm"}
                            color={"var(--chakra-colors-black)"}
                            noOfLines={1}
                        >
                            {member?.meta?.fullName}
                        </Text>
                        <Badge
                            variant={"outline"}
                            size={"sm"}
                            alignSelf={"flex-start"}
                        >
                            {t(`con.User:USERTYPE_${member?.meta?.userType}`)}
                        </Badge>
                    </Flex>
                </>
            ) : (
                <>
                    <Avatar
                        size={"sm"}
                        name={
                            isLoggedInUserTypeStudent
                                ? (
                                      data?.internshipSchedule as InternshipSchedule
                                  )?.name
                                : member?.meta?.fullName
                        }
                        src={useResolveUploadedPath(
                            APPC.BE.Upload.FILETYPE.FILETYPE_USER_AVATAR,
                            member?.meta?.imageName
                        )}
                        color={"var(--chakra-colors-primaryS10)"}
                        bgColor={"var(--chakra-colors-primaryT70)"}
                    >
                        {isNew && (
                            <AvatarBadge
                                boxSize="1em"
                                bg="var(--chakra-colors-destructive)"
                            />
                        )}
                    </Avatar>
                    <Flex direction={"column"} flexGrow={1} gap={0.5}>
                        <Text
                            textStyle={"mediumSm"}
                            color={"var(--chakra-colors-black)"}
                            noOfLines={1}
                        >
                            {isLoggedInUserTypeStudent
                                ? (
                                      data?.internshipSchedule as InternshipSchedule
                                  )?.name
                                : member?.meta?.fullName}
                        </Text>
                        {!isLoggedInUserTypeStudent && (
                            <Text
                                textStyle={"regularXs"}
                                color={"var(--chakra-colors-primaryS30)"}
                                noOfLines={1}
                            >
                                {
                                    (
                                        data?.internshipSchedule as InternshipSchedule
                                    )?.name
                                }
                            </Text>
                        )}
                    </Flex>
                </>
            )}
        </HStack>
    );
};
